// extracted by mini-css-extract-plugin
export default {"form":"Subscription_form__W-tMQ","input":"Subscription_input__gBycP","btn":"Subscription_btn__CHLak"};